import { IRow } from "../types";

export const form1HeaderCells = [
    "№п/п",
    "Наименование показателя, единица измерения",
    "Значение показателя в 2024 году*",
    "Плановое значение показателя",
    `
    Фактическое значение показателя за отчетный период (по отношению к предыдущемугоду,
    +/-)`,
    `
    Фактическое значение показателя за отчетный период (нарастающим итогом), единиц *
    ОМ+МК+КПК+КППК***`,
];

export const form1Rows: IRow[] = [
    {
        col1: "1",
        col2: "Увеличение числа мероприятий, проведенных центром прототипирования по отношению к предыдущему году, процент",
        col3: { name: "info.f1.n1.0" },
        col4: "5%",
        col5: { name: "info.f1.n1.2" },
        col6: { name: "info.f1.n1.3" },
    },
];
